import moment from "moment";

export const transformURL = (value) => {
  let newUrl = '';

  if (value.search('.com')) {
    for (let i = 0; i < value.search('.com') + 4; i++) {
      newUrl += value.charAt(i);
    }
  } else if (value.search('.ru')) {
    for (let i = 0; i < value.search('.ru') + 3; i++) {
      newUrl += value.charAt(i);
    }
  } else if (value.search('.by')) {
    for (let i = 0; i < value.search('.by') + 3; i++) {
      newUrl += value.charAt(i);
    }
  }
  return newUrl;
}

export const phoneNumberModification = (phoneNumber, hyphen = true) => {
  let modifiedPhoneNumber = ''
  if (phoneNumber) {
    modifiedPhoneNumber = phoneNumber.substring(0, 4) + ' (' +
      phoneNumber.substring(4, 6) + ') ' +
      phoneNumber.substring(6, 9) + (hyphen ? '-' : ' ') +
      phoneNumber.substring(9, 11) + (hyphen ? '-' : ' ') +
      phoneNumber.substring(11, phoneNumber.length);
  }

  return modifiedPhoneNumber
}

export const generateYears = (n) => {
  let currentYear = getCurrentEducationalYear();
  let years = []
  for (let i = 0; i < n; i++)
    years.push((currentYear - i).toString())
  return years;
}

export const setEducationForms = (specialities) => {
  const allEducationForms = specialities.map(speciality => {
    const arr = speciality.text.split(' ');
    return arr[arr.length - 1].slice(0, -1);
  });

  return Array.from(new Set(allEducationForms))
}

export const mapTree = (tree) => {
  for (let i = 0; i < tree.length; i++) {
    if (tree[i].children) {
      tree[i] = { ...tree[i], isExpanded: false }
      mapTree(tree[i].children)
    } else {
      tree[i] = { ...tree[i], isExpanded: false }
    }
  }
}

export const searchTree = (array, matchingTitle) => {
  let stack = [], node, ii;
  stack = [...array];

  while (stack.length > 0) {
    node = stack.pop();
    if (node.data.id === matchingTitle) {
      node[Object.keys(node)[2]] = !node[Object.keys(node)[2]]
      return node;
    } else if (node.children && node.children.length) {
      for (ii = 0; ii < node.children.length; ii += 1) {
        stack.push(node.children[ii]);
      }
    }
  }
  return null;
}

export const filterTree = (array, matchingTitle) => {
  let stack = [], node;
  stack = [...array];

  let result = []
  let completeResult = []
  let firstCompleteDepartmentId = null
  while (stack.length > 0) {
    node = stack.shift()
    let isRootMatch = false
    let isCompleteMatch = false
    node = {...node, isExpanded: false}
    if (matchingTitle !== '') {
      if ((node.data.abbrev.toUpperCase() === matchingTitle.toUpperCase() && node.data.employees.length !== 0)
          || node.data.employees.some(empl => empl.fio.toUpperCase().split(' ')[0] === matchingTitle.toUpperCase())
          || node.data.employees.some(empl => empl.phoneNumbers?.some(phoneNumber => phoneNumber.includes(matchingTitle.toUpperCase()))))   {
        isCompleteMatch = true
        if (!firstCompleteDepartmentId) firstCompleteDepartmentId = node.data.id
      } else if (node.data.name.toUpperCase().includes(matchingTitle.toUpperCase())
          || node.data.abbrev.toUpperCase().includes(matchingTitle.toUpperCase())
          || node.data.employees.some(empl => empl.fio.toUpperCase().includes(matchingTitle.toUpperCase()))
          || node.data.employees.some(empl => empl.phoneNumbers?.some(phoneNumber => phoneNumber.includes(matchingTitle.toUpperCase())))) {
        isRootMatch = true
      }
      if (node.children && node.children.length) {
        let childrenMatchResult = checkMatchingTitleForChildren(node, matchingTitle)
        if (childrenMatchResult[0]) {
          node = {...node, isExpanded: true}
          if (childrenMatchResult[0] === 2) {
            completeResult.push(node)
            if (!firstCompleteDepartmentId) firstCompleteDepartmentId = childrenMatchResult[1]
          } else result.push(node)
        } else if (isCompleteMatch) completeResult.push(node)
        else if (isRootMatch) result.push(node)
      } else if (isCompleteMatch) completeResult.push(node)
      else if (isRootMatch) result.push(node)
    }
  }
  return [completeResult.concat(result), firstCompleteDepartmentId];
}

function checkMatchingTitleForChildren(department, matchingTitle) {
  let match = 0 // 0 - not match, 1 - match, 2 - complete match
  let firstCompleteDepartmentId = null
  department.isExpanded = false
  for (const element of department.children) {
    if ((element.data.abbrev.toUpperCase() === matchingTitle.toUpperCase() && element.data.employees.length !== 0)
        || element.data.employees.some(empl => empl.fio.toUpperCase().split(' ')[0] === matchingTitle.toUpperCase())
        || element.data.employees.some(empl => empl.phoneNumbers?.some(phoneNumber => phoneNumber.includes(matchingTitle.toUpperCase())))) {
      match = 2
      if (!firstCompleteDepartmentId) firstCompleteDepartmentId = element.data.id
      department.isExpanded = true
    } else if (element.data.name.toUpperCase().includes(matchingTitle.toUpperCase())
        || element.data.abbrev.toUpperCase().includes(matchingTitle.toUpperCase())
        || element.data.employees.some(empl => empl.fio.toUpperCase().includes(matchingTitle.toUpperCase()))
        || element.data.employees.some(empl => empl.phoneNumbers?.some(phoneNumber => phoneNumber.includes(matchingTitle.toUpperCase())))) {
      department.isExpanded = true
      if (match !== 2) match = 1
    }
    if (element.children) {
      let childrenMatchResult = checkMatchingTitleForChildren(element, matchingTitle)
      if (childrenMatchResult[0]) {
        department.isExpanded = true
        if (match !== 2) {
          match = childrenMatchResult[0]
          if (!firstCompleteDepartmentId) firstCompleteDepartmentId = childrenMatchResult[1]
        }
      }
    }
  }
  return [match, firstCompleteDepartmentId]
}

export const getAllDepartmentIds = (departments) => {
  let allDepartmentsIds = []
  for (const dep of departments) {
    allDepartmentsIds.push(dep.data.id)
    if (dep.children) {
      allDepartmentsIds.push(...getAllDepartmentIds(dep.children))
    }
  }
  return allDepartmentsIds
}

export const getIdForScroll = (departments, idForScroll) => {
  for (let i = 0; i < departments.length; i++) {
    if (departments[i].data.id === idForScroll) return departments[i].data.id
    if (departments[i].children) {
      let id = setIsExpanded(departments[i], idForScroll)
      if(id !== null) return id
    }
  }
}

function setIsExpanded(department, idForScroll) {
  for (let i = 0; i < department.children.length; i++) {
    if (department.children[i].data.id === idForScroll) {
      department.isExpanded = true
      return department.data.id
    }
    if (department.children[i].children) {
      if (setIsExpanded(department.children[i], idForScroll)) {
        department.isExpanded = true
        return department.data.id
      }
    }
  }
  return null
}

export const getCurrentHalfOfYear = () => {
  const currentMonth = new Date().getMonth()
  if (currentMonth >= 0 && currentMonth <= 6) return 'Весенний'
  else return 'Осенний'
}

export const getCurrentEducationalYear = () => {
  const currentMonth = new Date().getMonth()
  if (currentMonth >= 0 && currentMonth <= 6) return new Date().getFullYear() - 1
  else return new Date().getFullYear()
}

export const getCurrentSemester = (course) => {
  if (getCurrentHalfOfYear() === 'Осенний') return (2 * course - 1)
  else return 2 * course
}

export const getUrlId = () => {
  if (localStorage.getItem('employeeUrlId')) {
    let employeeUrlId = JSON.parse(localStorage.getItem('employeeUrlId'))
    return employeeUrlId
  }
  return null
}

export const getGroup = () => {
  if (localStorage.getItem('group')) {
    let group = JSON.parse(localStorage.getItem('group'))
    return group
  }
  return null
}

export const getScheduleUrlId = () => {
  if (localStorage.getItem('scheduleUrlId')) {
    return `/${JSON.parse(localStorage.getItem('scheduleUrlId'))}`
  }
  return ''
}

export const createMarkup = (value) => {
  return { __html: value };
}

export const getWeekDayName = (date) => {
  const days = ['Воскресенье', 'Понедельник', 'Вторник', 'Среда', 'Четверг', 'Пятница', 'Суббота'];
  return days[date.getDay()];
}

//Returns DD.MM.YYYY string based on YYYY-MM-DD string
export const getFormattedDateString = (date) => {
  let source = date.toString();

  let year = parseInt(source.substring(0, 4));
  let month = parseInt(source.substring(5, 7));
  let day = parseInt(source.substring(8, 10));

  if (!year || !month || !day) return null;

  if (month < 10) month = '0' + month;
  if (day < 10) day = '0' + day;

  return day + '.' + month + '.' + year;
}

export const getFormattedDateSplittedByHyphens = (date) => {
  if(!date) return null;
  let dateFormat = new Date(date);
  let year = dateFormat.getFullYear();
  let month = dateFormat.getMonth() + 1;
  let day = dateFormat.getDate();

  if (!year || !month || !day) return null;

  if (month < 10) month = '0' + month;
  if (day < 10) day = '0' + day;

  return year + '-' + month + '-' + day;
}

export const getPosition = (string, subString, index) => {
  return string.split(subString, index).join(subString).length;
}

export const b64toBlob = (b64Data, contentType = '', sliceSize = 512) => {
  const byteCharacters = atob(b64Data);
  const byteArrays = [];

  for (let offset = 0; offset < byteCharacters.length; offset += sliceSize) {
    const slice = byteCharacters.slice(offset, offset + sliceSize);

    const byteNumbers = new Array(slice.length);
    for (let i = 0; i < slice.length; i++) {
      byteNumbers[i] = slice.charCodeAt(i);
    }

    const byteArray = new Uint8Array(byteNumbers);
    byteArrays.push(byteArray);
  }

  const blob = new Blob(byteArrays, { type: contentType });
  return blob;
}

export const blobToBase64 = (blob) => {
  return new Promise((resolve, _) => {
    const reader = new FileReader();
    reader.onloadend = () => resolve(reader.result);
    reader.readAsDataURL(blob);
  });
}

export const getImageDimensions = (file) => {
  return new Promise(function (resolved, _) {
    let i = new Image()
    i.onload = function () {
      resolved({ w: i.width, h: i.height })
    };
    i.src = file
  })
}

export const checkCyrillicLetters = (checkWord) => {
  let translatedWord = '';
  for (const ch of checkWord) {
    translatedWord += checkLetter(ch);
  }
  return translatedWord
}

function checkLetter(letter) {
  switch (letter) {
    case 'Q':
      return 'Й';
    case 'q':
      return 'й';
    case 'W':
      return 'Ц';
    case 'w':
      return 'ц';
    case 'E':
      return 'У';
    case 'e':
      return 'у';
    case 'R':
      return 'К';
    case 'r':
      return 'к';
    case 'T':
      return 'Е';
    case 't':
      return 'е';
    case 'Y':
      return 'Н';
    case 'y':
      return 'н';
    case 'U':
      return 'Г';
    case 'u':
      return 'г';
    case 'I':
      return 'Ш';
    case 'i':
      return 'ш';
    case 'O':
      return 'Щ';
    case 'o':
      return 'щ';
    case 'P':
      return 'З';
    case 'p':
      return 'з';
    case '{':
      return 'Х';
    case '[':
      return 'х';
    case '}':
      return 'Ъ';
    case ']':
      return 'ъ';
    case 'A':
      return 'Ф';
    case 'a':
      return 'ф';
    case 'S':
      return 'Ы';
    case 's':
      return 'ы';
    case 'D':
      return 'В';
    case 'd':
      return 'в';
    case 'F':
      return 'А';
    case 'f':
      return 'а';
    case 'G':
      return 'П';
    case 'g':
      return 'п';
    case 'H':
      return 'Р';
    case 'h':
      return 'р';
    case 'J':
      return 'О';
    case 'j':
      return 'о';
    case 'K':
      return 'Л';
    case 'k':
      return 'л';
    case 'L':
      return 'Д';
    case 'l':
      return 'д';
    case ':':
      return 'Ж';
    case ';':
      return 'ж';
    case '"':
      return 'Э';
    case "'":
      return 'э';
    case 'Z':
      return 'Я';
    case 'z':
      return 'я';
    case 'X':
      return 'Ч';
    case 'x':
      return 'ч';
    case 'C':
      return 'С';
    case 'c':
      return 'с';
    case 'V':
      return 'М';
    case 'v':
      return 'м';
    case 'B':
      return 'И';
    case 'b':
      return 'и';
    case 'N':
      return 'Т';
    case 'n':
      return 'т';
    case 'M':
      return 'Ь';
    case 'm':
      return 'ь';
    case '<':
      return 'Б';
    case ',':
      return 'б';
    case '>':
      return 'Ю';
    default:
      return letter;
  }
}

export const bytesToSize = (bytes) => {
  let sizes = ['Байт', 'KB', 'MB', 'GB', 'TB'];
  if (bytes === 0) return '0 Byte';
  let i = parseInt(Math.floor(Math.log(bytes) / Math.log(1024)));
  return Math.round(bytes / Math.pow(1024, i), 2) + ' ' + sizes[i];
}

export const isToday = (date) => {
  return new Date(date.replace(/(\d{2})\.(\d{2})\.(\d{4})/, '$3-$2-$1')).setHours(0, 0, 0, 0) === getTodayStart();
}

export const getTodayStart = () => {
  return new Date().setHours(0, 0, 0, 0);
}

//convert string dd.mm.yyyy to date yyyy-mm-dd
export const getDateFromString = (dateString) => {
  return new Date(dateString.replace(/(\d{2})\.(\d{2})\.(\d{4})/, '$3-$2-$1')).setHours(0, 0, 0, 0);
}

export const checkIfCurrentTime = (start, end) => {
  const startDate = new Date()
  const endDate = new Date()
  const currentDate = new Date()

  startDate.setHours(start.substring(0, 2))
  startDate.setMinutes(start.substring(3, 5))
  endDate.setHours(end.substring(0, 2))
  endDate.setMinutes(end.substring(3, 5))

  return (currentDate.getTime() >= startDate.getTime() && currentDate.getTime() <= endDate.getTime())
}

export const setWordEnding = (n, text_forms) => {
  n = Math.abs(n) % 100;
  const n1 = n % 10;
  if (n > 10 && n < 20) { return text_forms[2]; }
  if (n1 > 1 && n1 < 5) { return text_forms[1]; }
  if (n1 === 1) { return text_forms[0]; }
  return text_forms[2];
}

export const splitFio = (fio) => {
  const fioParts = fio.trim().split(/[ ]+/).map(fioPart => capitalizeName(fioPart));
  return [fioParts[0], fioParts[1], fioParts.slice(2).join(' ')];//1-е слово исходной строки – фамилия, 2 – имя, остальные – отчество
}

const capitalizeName = (name) => {
  return  name.split(/[-]+/).map(part => part[0]?.toUpperCase() + part.slice(1)?.toLowerCase()).join('-');
}

export const formatFioInitials = (fullFio) => {
  let fioInitials = "";
  const words = fullFio.split(' ');
  if (words && words.length > 0) {
      fioInitials = words[0];
      if (words.length > 1 && words[1]) {
          fioInitials += ' ' + words[1].charAt(0) + '.';
      }
      if (words.length > 2 && words[2]) {
          fioInitials += ' ' + words[2].charAt(0) + '.';
      }
  }
  return fioInitials;
}

export const formatFioWithInitials = (employee) => {
  let fio = employee.lastName ?? '';
  if (employee.firstName) {
    fio += ` ${employee.firstName.substring(0, 1)}.`;
  }
  if (employee.middleName) {
    fio += ` ${employee.middleName.substring(0, 1)}.`;
  }
  return fio;
}

export const formatFio = (employee) => {
  let fio = employee.lastName ?? '';
  if (employee.firstName) fio += ` ${employee.firstName}`;
  if (employee.middleName) fio += ` ${employee.middleName}`;
  return fio;
}

export const getFullName = (lastName, firstName, middleName) => {
  const fullName = (lastName ?? '') + ' ' + (firstName ?? '') + ' ' + (middleName ?? '');
  return fullName.trim();
}

export const blobToFile = (theBlob, fileName) => {
  theBlob.lastModifiedDate = new Date();
  theBlob.name = fileName;
  return theBlob;
}

export const stringToDate = (str) => {
  const tmp = str.split(".")
  const date = new Date(+tmp[2], tmp[1] - 1, +tmp[0])
  return date
}

export const stringToDateTime = (str) => {
  const time = str.split(':');
  const now = new Date();
  return new Date(now.getFullYear(), now.getMonth(), now.getDate(), ...time);
}

// Месяцы и дни начинаются с 1. Входит включительно
export const todayIsInRange = (startDateDay, startDateMonth, endDateDay, endDateMonth) => {
  const today = new Date();
  return dateIsInRange(today, startDateDay, startDateMonth, today.getFullYear(), endDateDay, endDateMonth, today.getFullYear());
}

export const dateIsInRange = (date, startDateDay, startDateMonth, startDateYear, endDateDay, endDateMonth, endDateYear) => {
  const dateToNumber = (date) => {
    return date.getFullYear() * 12 * 33 + (date.getMonth() + 1) * 32 + date.getDate();
  }
  const dateNumbersToNumber = (day, month, year) => {
    return year * 12 * 33 + month * 32 + day;
  }

  return dateToNumber(date) >= dateNumbersToNumber(startDateDay, startDateMonth, startDateYear)
      && dateToNumber(date) <= dateNumbersToNumber(endDateDay, endDateMonth, endDateYear);
}

export const getFormattedDateStringFromTimestamp = (timestamp) => {
    return timestamp ? moment(getDateFromMinskTimezone(new Date(timestamp))).format("DD.MM.YYYY") : null;
}

export const MINSK_TIMEZONE_OFFSET = 180;

export const getDateFromMinskTimezone = (date) => {
    return new Date(
        date.getFullYear(),
        date.getMonth(),
        date.getDate(),
        date.getHours(),
        +date.getTimezoneOffset() + MINSK_TIMEZONE_OFFSET,
        0
    );
}
